import { useEffect } from 'react';

import { useCookies } from 'react-cookie';

import { usePageEvent } from '@bonnet/next/use-page-event';

import useExperiments from '@/hooks/useExperiments';

export default function useNewRelicClientConfiguration({ reqId } = {}) {

    const { onPageEnter } = usePageEvent('newrelic');
    const { getActiveExperiments } = useExperiments();
    const activeExperiments = getActiveExperiments();
    const [cookies = {}] = useCookies(['abc', 'pxa_id']);
    const { abc, pxa_id: pxaId } = cookies;

    onPageEnter(() => {
        if (typeof window !== 'undefined') {
            if (window.newrelic && window.newrelic.setCustomAttribute) {
                // set newrelic attributes whenever a client route is loaded
                window.newrelic.setCustomAttribute('location', window.location && window.location.href);
                window.newrelic.addToTrace('location', window.location && window.location.href);
            }
        }
    });

    useEffect(() => {
        if (window.newrelic && window.newrelic.setCustomAttribute) {
            window.newrelic.setCustomAttribute('ATC_REQID', reqId);
        }

    }, [reqId]);

    useEffect(() => {
        if (window.newrelic && window.newrelic.setCustomAttribute) {
            window.newrelic.setCustomAttribute('abc', abc);
        }
    }, [abc]);

    useEffect(() => {
        if (window.newrelic && window.newrelic.setCustomAttribute) {
            window.newrelic.setCustomAttribute('pxa_id', pxaId);
        }
    }, [pxaId]);

    useEffect(() => {
        if (activeExperiments && window.newrelic && window.newrelic.setCustomAttribute) {
            window.newrelic.setCustomAttribute('experiments', activeExperiments.toString());
        }

    }, [activeExperiments]);

}
